import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Container, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import { createApplicationAction } from "../../../redux/actions/ApplicationAction";
import notify from "../../../Notifcation";
import { useNavigate } from "react-router-dom";

const Other = () => {
  const [desc, setdesc] = useState("");
  const [Nationalid, setNationalid] = useState("");
  const [ChoseServ, setChoseServ] = useState("");
  const [Others, setOthers] = useState([]);
  const navegate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [isPress, setisPress] = useState(false);
  const handleFileChangeNational = (e) => {
    // Convert FileList to Array
    const files = Array.from(e.target.files);
    setNationalid(files);
  };
  // const handleFileChangeelevakd = (e) => {
  //   // Convert FileList to Array
  //   const files = Array.from(e.target.files);
  //   setelevakd(files);
  // };
  const handleFileChangeOther = (e) => {
    // Convert FileList to Array
    const files = Array.from(e.target.files);
    setOthers(files);
  };
  const handlesubmit = async (e) => {
    e.preventDefault();
    if (Nationalid === "" ) {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    setisPress(true);
    const formData = new FormData();
    formData.append("application_type", 7);
    formData.append("local_type", 7);
    formData.append("local_category", ChoseServ);
    formData.append("local_details", desc);
    Nationalid.map((item) => {
      return formData.append("client_national_ids", item);
    });
    // elevakd.map((item) => {
    //   return formData.append("engineering_drawings", item);
    // });
    Others.map((item) => {
      return formData.append("others", item);
    });
    await dispatch(createApplicationAction(formData));
    setLoading(false);
    setisPress(false);
    setdesc("");
    setNationalid("");
    setChoseServ("");
    setOthers("");
  };
  const res = useSelector((state) => state.ApplicationReduser.createApp);

  useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 1500);
      if (res) {
        if (res.status === 201 || res.status === 200) {
          if (res.data) {
            notify(res.data.message, "success");
            setTimeout(() => {
              navegate("/user/requestsuser");
            }, 3000);
          }
        } else if (res.status !== 201 || res.status !== 200) {
          if (res.data) {
            notify(res.data.message, "error");
          } else {
            notify("حدثة مشكلة حاول مرة اخرى", "error");
          }
        }
      }
    }
  }, [loading]);
  return (
    <Container>
      {" "}
      <h3 className="text-center mb-3 mt-3">خدمات اخرى</h3>
      <div className="inputs-container">
        <div className="inp-container">
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              {
                <Typography>
                  نوع الخدمة
                  <span style={{ color: "red", fontSize: "21px" }}>*</span>
                </Typography>
              }
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label={
                <Typography>
                  نوع الخدمة
                  <span style={{ color: "red", fontSize: "21px" }}>*</span>
                </Typography>
              }
              value={ChoseServ}
              onChange={(e) => setChoseServ(e.target.value)}
            >
              <MenuItem value={25}>طلب توصيل عداد مرافق</MenuItem>
              <MenuItem value={26}>طلب توصيل مرافق دائم</MenuItem>
              <MenuItem value={27}>طلب الترخيص بتوصيل مرافق للمنازل القديمة</MenuItem>
              <MenuItem value={28}>طلب بالحفر لتوصيل المرافق</MenuItem>
              <MenuItem value={29}>طلب ترخيص او اقامة مدفن</MenuItem>
            </Select>
          </FormControl>
        </div>
        {/* {ChoseServ===1?(
        <div className="inp-container">
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              {
                <Typography>
                  نوع الخدمة
                  <span style={{ color: "red", fontSize: "21px" }}>*</span>
                </Typography>
              }
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label={
                <Typography>
                  نوع الخدمة
                  <span style={{ color: "red", fontSize: "21px" }}>*</span>
                </Typography>
              }
              value={ChoseServSub}
              onChange={(e) => setChoseServSub(e.target.value)}
            >
              <MenuItem value={'construction'}>انشاء</MenuItem>
              <MenuItem value={'amendment'}>تعديل</MenuItem>
              <MenuItem value={'addition'}>اضافة</MenuItem>
              <MenuItem value={'external_finishes'}>تشطيبات خارجية</MenuItem>
              <MenuItem value={'complete'}>استكمال</MenuItem>
              <MenuItem value={'raising'}>تعلية</MenuItem>

            </Select>
          </FormControl>
        </div>
        ):(null)} */}
        <div className="inp-container ">
          <TextField
            label={
              <Typography>
                البطاقة الشخصية
                <span style={{ color: "red", fontSize: "21px" }}>*</span>
              </Typography>
            }
            focused
            inputProps={{
              multiple: true,
            }}
            type="file"
            onChange={handleFileChangeNational}
            variant="outlined"
          />
        </div>
        {/* <div className="inp-container ">
          <TextField
            label={
              <Typography>
                صورة من رخصة البناء
                <span style={{ color: "red", fontSize: "21px" }}>*</span>
              </Typography>
            }
            focused
            // inputProps={{
            //   multiple: true,
            // }}
            type="file"
            onChange={(e) => setBuildLec(e.target.files[0])}
            variant="outlined"
          />
        </div>
        <div className="inp-container ">
          <TextField
            label={
              "طلب الترخيص"
            }
            focused
            // inputProps={{
            //   multiple: true,
            // }}
            type="file"
            onChange={(e) => setRequestLec(e.target.files[0])}
            variant="outlined"
          />
        </div>
        <div className="inp-container ">
          <TextField
            label={
              "صورة من البطاقة الضريبية"
            }
            focused
            // inputProps={{
            //   multiple: true,
            // }}
            type="file"
            onChange={(e) => setTaxcard(e.target.files[0])}
            variant="outlined"
          />
        </div>
        <div className="inp-container ">
          <TextField
            label={"مستخرج رسمي من المحل التجاري"}
            focused
            // inputProps={{
            //   multiple: true,
            // }}
            type="file"
            onChange={(e) => setOfficialComm(e.target.files[0])}
            variant="outlined"
          />
        </div>
        <div className="inp-container ">
          <TextField
            label={"شهادة صحية لجميع العاملين"}
            focused
            // inputProps={{
            //   multiple: true,
            // }}
            type="file"
            onChange={(e) => setCertEmpp(e.target.files[0])}
            variant="outlined"
          />
        </div>
        <div className="inp-container ">
          <TextField
            label={"صورة من مستند الملكية (عقد الملكية- الايجار) ساري لمدة مناسبة وموضح النشاط"}
            focused
            // inputProps={{
            //   multiple: true,
            // }}
            type="file"
            onChange={(e) => setTitedeed(e.target.files[0])}
            variant="outlined"
          />
        </div>
        <div className="inp-container ">
          <TextField
            label={"افادة من التنظيم بموقف المحل (رخصة - تقنين)"}
            focused
            // inputProps={{
            //   multiple: true,
            // }}
            type="file"
            onChange={(e) => setCertmoqf(e.target.files[0])}
            variant="outlined"
          />
        </div>
        <div className="inp-container ">
          <TextField
            label={"شهادة تصرف عقاري"}
            focused
            // inputProps={{
            //   multiple: true,
            // }}
            type="file"
            onChange={(e) => setCertTasarof(e.target.files[0])}
            variant="outlined"
          />
        </div>
        <div className="inp-container ">
          <TextField
            label={"تقرير هندسي معتمد يثبت السلامة الأنشائية"}
            focused
            // inputProps={{
            //   multiple: true,
            // }}
            type="file"
            onChange={(e) => setEngReport(e.target.files[0])}
            variant="outlined"
          />
        </div>
        <div className="inp-container ">
          <TextField
            label={"رسم كروكي يوضح مكان المحل يحتوي على (العنوان-الحي-الشارع-الرقم"}
            focused
            // inputProps={{
            //   multiple: true,
            // }}
            type="file"
            onChange={(e) => setqoroke(e.target.files[0])}
            variant="outlined"
          />
        </div>
        <div className="inp-container ">
          <TextField
            label={"توكيل"}
            focused
            // inputProps={{
            //   multiple: true,
            // }}
            type="file"
            onChange={(e) => setPower(e.target.files[0])}
            variant="outlined"
          />
        </div> */}
        <div className="inp-container ">
          <TextField
            label={"تفاصيل"}
            multiline
            type="text"
            value={desc}
            onChange={(e) => {
              setdesc(e.target.value);
            }}
            variant="outlined"
          />
        </div>

        <div className="inp-container ">
          <TextField
            label={"اخرى"}
            focused
            inputProps={{
              multiple: true,
            }}
            type="file"
            onChange={handleFileChangeOther}
            variant="outlined"
          />
        </div>
        <div className="inp-container "></div>
        <div className="inp-container "></div>
      </div>
      {isPress && loading ? (
        <button className="buttonadd">
          <Spinner />
        </button>
      ) : (
        <button className="buttonadd" onClick={handlesubmit}>
          {" "}
          استكمال الطلب
        </button>
      )}
      <ToastContainer />
    </Container>
  );
};

export default Other;
